//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 20/09/2023
// Version       : 1
// Description   : Activar/Anular tareas para tipos de vehiculos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  Snackbar,
} from "@mui/material";

//Notification
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CambiarEstadoTareaTipoVehiculo({ onClose, tarea, onGuardarEstado }) {
  const isTareaActiva = tarea.estado === 1; // Si la tarea está activa (estado 1)
  // Deshabilitar Botón
  const [disBtn, setDisBtn] = useState(false);
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // ------------------------------------------------------------------

  // FUNCIONES PARA GUARDAR EL ESTADO DE LAS TAREAS
  const guardarActivoTarea = async (tarea) => {
    console.log("Estoy por activar la tarea");
    await fetch(UrlApi + "/tareas_tipo_vehiculos/" + tarea.id_tarea, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        estado: 1, // Activar tarea
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La tarea se activó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al activar la tarea");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const guardarInactivoTarea = async (tarea) => {
    console.log("Estoy por desactivar la tarea");
    await fetch(UrlApi + "/tareas_tipo_vehiculos/" + tarea.id_tarea, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        estado: 2, // Desactivar tarea
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La tarea se desactivó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al desactivar la tarea");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // Manejar el guardado de estado
  const handleGuardarEstado = () => {
    if (isTareaActiva) {
      setDisBtn(true);

      guardarInactivoTarea(tarea); // Si está activa, la desactiva
    } else {
      setDisBtn(true);
      guardarActivoTarea(tarea); // Si está inactiva, la activa
    }
  };

  //*************************************************************************************************************************************/

  // Snackbar Notificacion
  // Cerrar el Snackbar y realizar las acciones finales
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);

    // Acciones de cierre de diálogo y actualización después de que el Snack se cierre
    onGuardarEstado();
    onClose();
  };

  //*************************************************************************************************************************************/

  return (
    <>
      <Box
        style={{
          borderWidth: 2,
          borderStyle: "solid",
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle sx={{ padding: 0, marginBottom: 2 }}>
          <Box
            sx={{
              backgroundColor: "#2B76A6",
              width: "100%",
              padding: "8px 0",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              <b>{isTareaActiva ? "ANULAR" : "ACTIVAR"} TAREA</b>
            </Typography>
          </Box>{" "}
        </DialogTitle>

        <DialogContent>
          <Typography align="center">{tarea.tarea}</Typography>
        </DialogContent>

        <Typography align="center" sx={{ fontWeight: "bold" }}>
          {isTareaActiva
            ? "¿Desea anular esta tarea?"
            : "¿Desea activar esta tarea?"}
        </Typography>
        <DialogActions>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              sx={{
                backgroundColor: "#d32f2f",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#b71c1c", // Un rojo más oscuro en hover
                },
                "&:disabled": {
                  // Estilo para el botón en estado deshabilitado
                  backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar de Material-UI
                  color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                },
              }}
              onClick={onClose}
              variant="contained"
              disabled={disBtn}
            >
              Volver
            </Button>
            <Button
              sx={{
                color: "#ffffff",
                "&:disabled": {
                  // Estilo para el botón en estado deshabilitado
                  backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar
                  color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                },
              }}
              onClick={handleGuardarEstado}
              variant="contained"
              disabled={disBtn}
            >
              {isTareaActiva ? "Anular" : "Activar"}
            </Button>
          </Box>
        </DialogActions>
      </Box>

      {/* SNACKBAR QUE SE MOSTRARA AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CambiarEstadoTareaTipoVehiculo;
